(function() {
    angular.module('tmx-app')
        .controller('customersEditCtrl', ['$scope', 'resolvedData','tmxUtility','TMX_FINANCE_CONSTANTS', 'lookupService',
            '$state', '$location', '$anchorScroll','CustomersService','$http','APP_CONSTANTS', 'ToastService','TmxDialogService',

            function CustomersEditCtrl($scope, resolvedData,tmxUtility, TMX_FINANCE_CONSTANTS, lookupService, $state,
                $location, $anchorScroll,CustomersService,$http,APP_CONSTANTS, ToastService,TmxDialogService) {
                var customerVM = this;
                customerVM.vm = resolvedData.Customer.data;
                customerVM.isEdit=false;
                customerVM.loading=false;
                customerVM.CustomersService=CustomersService;
                customerVM.CNICExpiryInvalid=false;
                customerVM.BirthDateInvalid = false;
                customerVM.tenant= APP_CONSTANTS.tenant;                
                customerVM.Organizations = resolvedData.Organizations.data.filter(x=>x.Active_Flag ===1);
                customerVM.OrganizationRelations = resolvedData.OrganizationRelations;
                customerVM.addMapping = addMapping;
                customerVM.deleteMapping = deleteMapping;
                customerVM.RelationMapping = [];
                customerVM.currentDate= new Date();
                var showActionToast = ToastService.showActionToast;
                var showConfirmDialog = TmxDialogService.showConfirmDialog;
                var lkupType = TMX_FINANCE_CONSTANTS.LOOKUP_TYPES;                
                var exists = tmxUtility.exists;

        ///////////////////FUNCTIONS////////////////////////
                function addMapping() {
                    var Details = {

                        tempOrganizationRelationMapping: [],
                        RelationStatusLkpId: 0

                    };
                    if (!customerVM.RelationMapping)
                        customerVM.RelationMapping = [];
                    customerVM.RelationMapping.push(Details);

                }
                function deleteMapping(index) {                    
                    showConfirmDialog("Confirmation", "Are you sure you want to remove this Detail?", function () {                     
                        customerVM.RelationMapping.splice(index, 1);
                    });
                }

                customerVM.checkCnic=function(){
             
                    if(angular.isDefined(customerVM.customerNIMapping.NationalIdentifierValue)) {
             //if(!customerVM.isEdit)
             //{

                        var action='GetByCnic/'+customerVM.customerNIMapping.NationalIdentifierValue+'/string';
                        var url = APP_CONSTANTS.backend;
                        $http.get(url+"CustomerMaster/"+action).then(function(response){
                      
                            if(response.data.data==true) {
                                customerVM.dialogForm.CNIC.$error.alreadyexist=true;
                                customerVM.dialogForm.CNIC.$invalid=true;
                                customerVM.dialogForm.CNIC.$valid=false;
                            }
                            else{
                                customerVM.dialogForm.CNIC.$error.alreadyexist=false;
                                customerVM.dialogForm.CNIC.$invalid=false;
                                customerVM.dialogForm.CNIC.$valid=true;
                                customerVM.error_msg=customerVM.error_msg.replace("CNIC,","");
                            }
                        });
             //}

                    }
                };
        ////////////////////////////////////////////
                customerVM.addPhoneField=function(){
                    if(!angular.isDefined(customerVM.phoneNumberCount))
                        customerVM.phoneNumberCount=1;
                    customerVM.phoneNumberFields.push({
                        type:1,
                        number:null,
                        ext:null
                    });
                    customerVM.phoneNumberCount++;
                }
                customerVM.formatPhoneNumber=function(PhoneNumber1){
                    if(angular.isDefined(PhoneNumber1) && PhoneNumber1!=null) {
                        var country = PhoneNumber1.slice(0,2);
                        var city = PhoneNumber1.slice(2,5);
                        var number = PhoneNumber1.slice(5);
                        number = number.slice(0, 3) + '-' + number.slice(3,7);
                        return "+"+country+" (" +city+") "+number;
                    }
                    return "N/A";
                };
        /////////////////////////////DATE FUNCTIONS//////////////////////////////////////////////////////////////
        ///////////////////////START DATE SELECTED/////////////////////////////////////////////////////////////////
                customerVM.onStartDateSelected = function(selectedDate) {
                    if(selectedDate!=null) {
                        customerVM.vm.EffectiveStartDate = selectedDate.toJSON();//start Date
                        customerVM.StartDateInvalid = false;
                        customerVM.minEndDate = customerVM.vm.EffectiveStartDate;//ensuring that end date >= start Date

                //calling validation function passing in strings
                //$scope.checkEndDate();

                    }
                    else{
                        customerVM.StartDateInvalid = true;
                    }
                    var st = customerVM.getStatus();
                    customerVM.currentStatus = st;
                };
        ////////////////////////////////END DATE SELECTED///////////////////////////////////////////////////////////
                customerVM.onEndDateSelected = function(selectedDate) {
                    if(selectedDate != null ) {

                        customerVM.vm.EffectiveEndDate = selectedDate.toJSON();//end Date
                        customerVM.EndDateInvalid = false;
                    }
                    else{
                        customerVM.EndDateInvalid = true;

                    }
                    var st = customerVM.getStatus();
                    customerVM.currentStatus = st;
                };
        /////////////////////////////////CNIC EXPIRY DATE SELECTED/////////////////////////////////////////////////
                customerVM.onExpiryDateSelected = function(selectedDate) {
                    if(selectedDate != null ) {

                        customerVM.customerNIMapping.NationalIDExpiryDate = selectedDate.toJSON();//end Date
                        customerVM.CNICExpiryInvalid = false;
                    }
                    else{
                        customerVM.CNICExpiryInvalid = true;

                    }
                };
        //////////////////////////////////BIRTH DATE SELECTED////////////////////////////////////////////////////
                customerVM.onBirthDateSelected = function(selectedDate) {
                    if(selectedDate != null ) {
               // customerVM.vm.TmxCustomerHousehold[0].DateOfBirth = selectedDate.toJSON();//end Date
                        customerVM.vm.TmxCustomerDetail[0].TmxPerson.PersonDateOfBirth = selectedDate.toJSON();
                        customerVM.BirthDateInvalid = false;
                    }
                    else{
                        customerVM.BirthDateInvalid = true;

                    }
                };
        ////////////////////////////////////////////////////////////////////////////////////////////////////////
                customerVM.onResidenceDurationSelection = function(selectedDate){
                    if(selectedDate != null ) {
                        customerVM.ResidenceDurationInvalid = false;
                    }
                    else{
                        customerVM.ResidenceDurationInvalid = true;

                    }
                };
        ////////////////////////////////////////////////////////////////////////////////////////////////////
        // customerVM.getStatus = function() {
        //   if (angular.isDefined(customerVM.vm.EffectiveEndDate) && angular.isDefined(customerVM.vm.EffectiveStartDate)) {
        //     if (customerVM.vm.EffectiveEndDate > customerVM.date && customerVM.vm.EffectiveStartDate < customerVM.date) {
        //       return "Active";
        //     }
        //   }
        //   return "Inactive";
        // }
                customerVM.getStatus = function() {


                    if(customerVM.vm.EffectiveEndDate!="Invalid Date" && customerVM.vm.EffectiveStartDate!=null) {
                        var todayDate = customerVM.date.split("T");
                        todayDate = todayDate[0];
                        var startDate = customerVM.vm.EffectiveStartDate.split("T");
                //startDate = startDate[0];
                        var endDate = customerVM.vm.EffectiveEndDate.split("T");
                        endDate = endDate[0];


                        if(customerVM.vm.EffectiveEndDate <= customerVM.date ){
                            return "Inactive";
                        }
                        if ( startDate == todayDate && endDate >=todayDate) {
                            return "Active";
                        }
                        else if ( startDate > todayDate){
                            return "Pending";
                        }
                    }
                    return "Pending";
                }
 /////////////////////////////////////////////POPULATE END DATE///////////////////////////////////////////////////////
                $scope.populateCustomerDate = function(entityDate){
                    var EndDate ;
                    if(entityDate) {
                        EndDate = new Date(entityDate);//forming a date object from JSON string
                    }
                    else {
                        EndDate = new Date();
                    }
                    return EndDate;
                };
/////////////////////////////////// ERRORS /////////////////////////////////////////////////////////////////////////////
                customerVM.getOtherErrors = function(){
                    customerVM.DisabilityInvalid = false;
                    customerVM.TrainingSpecInvalid = false;
             
                    if(!angular.isDefined(customerVM.vm) || !angular.isDefined(customerVM.vm.TmxCustomerDetail[0].TmxPerson)){
                        return undefined;
                    }
                    if(customerVM.DisabilityNatureRequired && customerVM.vm.TmxCustomerDetail[0].TmxPerson.PersonDisabilityNature==""){
                        customerVM.DisabilityInvalid = true;

                    }
                    if(customerVM.TrainingSpecRequired &&
               (customerVM.vm.TmxCustomerDetail[0].TmxPerson.PersonTechnicalVocationalTraining=="" ||
                !angular.isDefined(customerVM.vm.TmxCustomerDetail[0].TmxPerson.PersonTechnicalVocationalTraining))                                    ){
                        customerVM.TrainingSpecInvalid = true;
                    }
            ////////////////////////////////////////
                    if(customerVM.TrainingSpecInvalid == false &&  customerVM.DisabilityInvalid == true){
                 
                        return  customerVM.vm.TmxCustomerDetail[0].TmxPerson.PersonDisabilityNature;
                    }
                    else if(customerVM.TrainingSpecInvalid == true &&  customerVM.DisabilityInvalid == false){
                 
                        return  customerVM.vm.TmxCustomerDetail[0].TmxPerson.PersonTechnicalVocationalTraining;
                    }
                    else if(customerVM.TrainingSpecInvalid == true &&  customerVM.DisabilityInvalid == true){
                 
                        return  ([customerVM.vm.TmxCustomerDetail[0].TmxPerson.PersonTechnicalVocationalTraining,
                            customerVM.vm.TmxCustomerDetail[0].TmxPerson.PersonDisabilityNature]);
                    }
                    else{
                        return undefined;
                    }

                };
                customerVM.getFormErrors = function() {
            // customerVM.vm.TmxCustomerDetail[0].TmxPerson[0].PersonResidenceDuration=="Invalid Date" ||
                    if(angular.isDefined(customerVM.dialogForm)) {
                        if(customerVM.dialogForm.$invalid ||
                    customerVM.dialogForm.CNIC.$error.alreadyexist ||
                    customerVM.customerNIMapping.NationalIDExpiryDate=="Invalid Date" ||
                    customerVM.vm.TmxCustomerDetail[0].TmxPerson.PersonDateOfBirth=="Invalid Date" ||
                     customerVM.vm.EffectiveEndDate =="Invalid Date" ) {
                            if(angular.isDefined(customerVM.dialogForm.$error.required)) {
                                if(customerVM.dialogForm.$error.required.length>0) {
                                    customerVM.formInvalid = true;
                                    return customerVM.dialogForm.$error;
                                }
                            }
                    //else if( customerVM.customerNIMapping.NationalIDExpiryDate=="Invalid Date" ||
                    //    customerVM.vm.TmxCustomerHousehold[0].DateOfBirth=="Invalid Date" ||
                    //    customerVM.vm.EffectiveEndDate =="Invalid Date" ||
                    //    customerVM.vm.TmxCustomerHousehold[0].ResidenceDuration=="Invalid Date")
                    //{
                    //    customerVM.formInvalid = true;
                    //    return customerVM.dialogForm.$error;
                    //}
                        }
                    }
                    customerVM.formInvalid = false;
                    return undefined;
                };
///////////////////////////////////////////////////
                customerVM.getDateErrors = function(){
                    customerVM.CNICExpiryInvalid = false;
                    customerVM.BirthDateInvalid = false;
                    customerVM.ResidenceDurationInvalid =false;
                    customerVM.EndDateInvalid = false;
                    var ErrorDateArr=[];
                    if(angular.isDefined(customerVM.dialogForm)) {
                        if( customerVM.customerNIMapping.NationalIDExpiryDate=="Invalid Date") {
                            customerVM.CNICExpiryInvalid = true;
                        }
                        if(customerVM.vm.TmxCustomerDetail[0].TmxPerson.PersonDateOfBirth=="Invalid Date"  ) {
                            customerVM.BirthDateInvalid = true;
                        }
                // if( customerVM.vm.TmxCustomerDetail[0].TmxPerson.PersonResidenceDuration==null  )
                // {
                //     customerVM.ResidenceDurationInvalid =true;
                // }
                        if(customerVM.vm.EffectiveEndDate =="Invalid Date") {
                            customerVM.EndDateInvalid = true;
                        }
                //pushing Date values in array
                        ErrorDateArr.push(customerVM.CNICExpiryInvalid,customerVM.BirthDateInvalid,
                            customerVM.ResidenceDurationInvalid, customerVM.EndDateInvalid);
                        return ErrorDateArr;
                    }
                    return undefined
                };
            ////////////////////////////////////////////////////////////////////////
                customerVM.errorChanged = function(newErrors,oldErrors) {

            //customerVM.vm.TmxCustomerDetail[0].TmxPerson.PersonResidenceDuration=="Invalid Date" ||
                    if(newErrors!=oldErrors ||
                customerVM.customerNIMapping.NationalIDExpiryDate=="Invalid Date" ||
                customerVM.vm.TmxCustomerDetail[0].TmxPerson.PersonDateOfBirth=="Invalid Date" ||
                customerVM.vm.EffectiveEndDate=="Invalid Date" ||
                (customerVM.DisabilityNatureRequired && customerVM.vm.TmxCustomerDetail[0].TmxPerson.PersonDisabilityNature=="") ||
                (customerVM.TrainingSpecRequired && customerVM.vm.TmxCustomerDetail[0].TmxPerson.PersonTechnicalVocationalTraining=="")
                    ) {
                        customerVM.dirtyFormControls = [];
                        angular.forEach(customerVM.dialogForm, function(value, key) {
                            if ((typeof value === 'object' && value.hasOwnProperty('$modelValue') && value.$invalid) ||
                        (typeof value === 'object' && value.$viewValue=="Invalid Date")) {
                                if(value.$name=="Disability Nature") {
                             
                                    if(!customerVM.disableDisabilityField && value.$error != {}) {
                                        customerVM.dirtyFormControls.push(value.$name);
                                    }
                                }
                                else if(value.$name=="Training Specifications") {
                             
                                    if(!customerVM.disableTrainingsField) {
                                        customerVM.dirtyFormControls.push(value.$name);
                                    }
                                }
                                else {
                             
                                    if(key=="MobileNumber"){
                                        var name = value.$name;
                                        name = name.replace(/([A-Z])/g, ' $1').trim();
                                        value.$name=name;
                                    }
                             
                                    customerVM.dirtyFormControls.push(value.$name);
                                }
                            }
                        });
                 
                        customerVM.error_msg = "Required field(s): ";
                        for (var i = 0; i < customerVM.dirtyFormControls.length; i++) {
                            if(i==customerVM.dirtyFormControls.length-1) {
                                customerVM.error_msg +=  customerVM.dirtyFormControls[i];
                            }
                            else
                                customerVM.error_msg +=  customerVM.dirtyFormControls[i] + ", ";
                        }
                    }
                };
/////////////////////////////////////////////////////
                $scope.$watch(customerVM.getDateErrors, customerVM.errorChanged,true);
                $scope.$watch(customerVM.getFormErrors, customerVM.errorChanged,true);
                $scope.$watch(customerVM.getOtherErrors, customerVM.errorChanged,true);

        
/////////////////////////////////////SAVE //////////////////////////////////////////////////////////////////////////////
                customerVM.save = function(action,form) {                    
            // customerVM.vm.TmxCustomerHousehold[0].ResidenceDuration=="Invalid Date" ||
                    customerVM.formSubmitted = true;
                    customerVM.bypassForm = false;
                    customerVM.errorCount = 0;
                    customerVM.formError = false;
                    if (form.$invalid || customerVM.customerNIMapping.NationalIDExpiryDate=="Invalid Date" ||
                customerVM.vm.TmxCustomerDetail[0].TmxPerson.PersonDateOfBirth=="Invalid Date" ||
                customerVM.vm.EffectiveEndDate=="Invalid Date" ||
                 customerVM.DisabilityInvalid || customerVM.TrainingSpecInvalid ||
                customerVM.dialogForm.CNIC.$error.alreadyexist
                    ) {
                 
                        customerVM.dirtyFormControls = [];
                        customerVM.formInvalid = true;

                        angular.forEach(form, function(value) {

                            if ((typeof value === 'object' && value.hasOwnProperty('$modelValue') && value.$invalid)
                        || (typeof value === 'object' && value.$viewValue=="Invalid Date")) {
                                if(value.$name=="Disability Nature") {
                             
                                    if(!customerVM.disableDisabilityField) {
                                        value.$setTouched();
                                        customerVM.errorCount++;
                                        customerVM.dirtyFormControls.push(value.$name);
                                        customerVM.DisabilityInvalid = true;
                                    }
                                    else{
                                        if(customerVM.errorCount>0){
                                            customerVM.errorCount--;
                                        }

                                    }

                                }
                                else if(value.$name=="Training Specifications") {
                         
                                    if(!customerVM.disableTrainingsField) {
                                        value.$setTouched();
                                        customerVM.errorCount++;
                                        customerVM.dirtyFormControls.push(value.$name);
                                    }
                                    else{
                                        if(customerVM.errorCount>0){
                                            customerVM.errorCount--;
                                        }

                                    }

                                }
                                else {
                                    value.$setTouched();
                                    customerVM.errorCount++;
                                    customerVM.formError = true;
                                    customerVM.dirtyFormControls.push(value.$name);
                                }
                            }
                        });

                 
                        if(customerVM.errorCount<=0 && !customerVM.formError)
                            customerVM.bypassForm = true;
                    }
                    else {
             
                        customerVM.bypassForm = true;
                    }
             
                    if(!customerVM.bypassForm) {
                        customerVM.error_msg = "Required field(s): ";
                        for (var i = 0; i < customerVM.dirtyFormControls.length; i++) {
                            if(i==customerVM.dirtyFormControls.length-1){
                                customerVM.error_msg +=  customerVM.dirtyFormControls[i];
                            }
                            else{
                                customerVM.error_msg +=  customerVM.dirtyFormControls[i] + ", ";
                            }
                        }
                        $location.hash('error');
                        $anchorScroll.yOffset = 600;
                // call $anchorScroll()
                        $anchorScroll();
                    }
                    else{                        
                        customerVM.loading=true;
                        customerVM.formInvalid = false;
                        customerVM.DisabilityInvalid = false;
                        customerVM.TrainingSpecInvalid=false;                        
                        customerVM.vm.TmxCustomerBankingDetails=[];
                //customerVM.vm.TmxCustomerDetail[0].TmxPerson.PersonResidenceDuration=0.00;
                        var startDate = tmxUtility.setStartDate(customerVM.vm.EffectiveStartDate);
                /* splitting the time in case of effective end date as adding constant of 23 hours
                 adds up and take it to next day date*/
                        var endDate = tmxUtility.setEndDate(customerVM.vm.EffectiveEndDate);
                        customerVM.vm.EffectiveStartDate = startDate.toJSON();//JSON date sen to backend
                        customerVM.vm.EffectiveEndDate = endDate.toJSON();//JSON date sen to backend                                                
                // customerVM.loading=true;
                        if(angular.isDefined(customerVM.vm.TmxCustomerDetail[0].TmxPerson.PersonMiddleName) && customerVM.vm.TmxCustomerDetail[0].TmxPerson.PersonMiddleName!=null)
                            customerVM.vm.CustomerName = customerVM.vm.TmxCustomerDetail[0].TmxPerson.PersonFirstName + " " + customerVM.vm.TmxCustomerDetail[0].TmxPerson.PersonMiddleName + " " + customerVM.vm.TmxCustomerDetail[0].TmxPerson.PersonLastName;
                        else
                            customerVM.vm.CustomerName = customerVM.vm.TmxCustomerDetail[0].TmxPerson.PersonFirstName + " " + customerVM.vm.TmxCustomerDetail[0].TmxPerson.PersonLastName;
                        customerVM.vm.CustomerCode = "TEST";
                        customerVM.vm.LoanApplicationId=null;
                        customerVM.vm.TmxCustomerDetail[0].TmxPerson.PersonGenderLkp=Number(customerVM.vm.TmxCustomerDetail[0].TmxPerson.PersonGenderLkp);
                //customerVM.loading=true;
   
                        

                        var cnic ={
                            NationalIdentifierValue:"",
                            NationalIdExpiryDate: new Date(undefined)
                        }                        
                        if(customerVM.vm.TmxCustomerDetail[0].TmxPerson.TmxPersonNationalIdentifier.length==0 && exists(customerVM.vm.TmxCustomerDetail[0].TmxPerson.TmxPersonNationalIdentifier)){
                        customerVM.vm.TmxCustomerDetail[0].TmxPerson.TmxPersonNationalIdentifier.push(cnic);
                    }
            
                        customerVM.vm.NationalIdentifierValue=customerVM.customerNIMapping.NationalIdentifierValue;
                        customerVM.vm.NationalIdTypeLkp=NationalIdTypeLkp;
                        customerVM.vm.TmxCustomerDetail[0].TmxPerson.TmxPersonNationalIdentifier[0].NationalIdentifierValue=customerVM.customerNIMapping.NationalIdentifierValue;
                        customerVM.vm.TmxCustomerDetail[0].TmxPerson.TmxPersonNationalIdentifier[0].NationalIdExpiryDate=customerVM.customerNIMapping.NationalIDExpiryDate;

                        customerVM.vm.TmxCustomerBankingDetails.push(customerVM.vm.TmXCustomerBankingDetail);

                        customerVM.vm.TmXCustomerOrganizationRelationMapping=[];
                        customerVM.RelationMapping.forEach(function(obj){
                            obj.tempOrganizationRelationMapping.forEach(function(item){
                                customerVM.vm.TmXCustomerOrganizationRelationMapping.push({
                                    RelationStatusLkpId:obj.RelationStatusLkpId,
                                    OrganizationID:item.OrganizationId,
                                    CustomerToOrganizationRelationMapping:item.CustomerToOrganizationRelationMapping
                                });        
                            });
                        });
                        
                         customerVM.vm.TmXCustomerBankingDetail=null;

                        customerVM.vm.$saveOrUpdate().then(function(promise) {
                    //  customerVM.vm.TmxCustomerDetail[0].TmxPerson.TmxPersonNationalIdentifier.push(cnic);
                    // if(angular.isDefined($state.data.grid.customerGrid)) $state.data.grid.customerGrid.dataSource.read();
                            customerVM.loading=false;
                            if(angular.isDefined(promise)) {
                                if(promise.status>=400) {
                                    customerVM.formSubmitted = false;
                                    var displayMsg = "";
                                    if(angular.isDefined(promise.data.ModelState)) {
                                        var models=Object.keys(promise.data.ModelState);
                                        models.forEach(function (key){displayMsg+=(promise.data.ModelState[key])})
                                    }
                                    else
                                        displayMsg = promise.data.Message;
                            // customerVM.error_msg = promise.statusText;
                                    showActionToast("error",displayMsg);

                                }
                                else {
                                    if(action=="save") {
                                        $state.searchClear = true;
                                        $state.go("^");
                                    }
                                    else if(action=="saveandnew") {
                                        $state.searchClear = true;
                                        $state.reload($state.current);
                                    }
                                }
                            }
                            else
                                showActionToast("error","Some Error Occured");
                        });
                    }
                };
////////////////////////////////////CANCEL FORM/////////////////////////////////////////////////////////////////////////
                customerVM.cancel = function() {
                    $state.searchClear = true;
                    $state.go("^");
                };
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                customerVM.statusChange = function() {
                };
/////////////////////////////////// INITIALIZATIONS ///////////////////////////////////////////////////////////////////
                customerVM.date = new Date().toJSON();
                customerVM.loading=false;
        // customerVM.gridData = {};//resolvedData.locations.data;
                customerVM.phoneNumberFields=[];
                customerVM.addPhoneField();
                customerVM.isEdit = false;
        //customerVM.DisabilityNatureRequired =false;
        // customerVM.designationsLookup = resolvedData.Designations.data;
        // customerVM.usersLookup = resolvedData.Users.data;
        // customerVM.Devices = resolvedData.Devices.data;
                customerVM.endmindate = angular.copy(customerVM.date);
                customerVM.dirtyFormControls = [];
                customerVM.StartDateInvalid = false;
                customerVM.EndDateInvalid = false;
//////////////////////////DATE TIME PICKER CONFIGURATIONS/////////////////////
                customerVM.currentdateObj = new Date();
                customerVM.date = customerVM.currentdateObj.toJSON();

        //customerVM.minEnddate = angular.copy(customerVM.date);
                customerVM.StartDateReadonly = false;
                customerVM.EndDateReadonly = false;
                customerVM.readonly = false;
                customerVM.tenant= APP_CONSTANTS.tenant;
                var vitasTenants = ["vitas","vitas-leb","vitas-eg"];
                var LookUpName = "";

                if(vitasTenants.indexOf(customerVM.tenant.toLowerCase()) > -1) {
                    LookUpName = lkupType.IdentificationDocumentTypes;          
                }
        
                if(customerVM.tenant == 'SilkBank') {
                    LookUpName = lkupType.ID_TYPE;
                }
                var NationalIdTypeLkp= 0;
                lookupService.getLookupByType(LookUpName).then(function(IdentifierTypeLkp) {                     
                    customerVM.IdentifierLkp = IdentifierTypeLkp;
         
                    customerVM.IdentifierLkp.forEach(function(obj) {
                        if(obj.VisibleValue =='National ID')
                            NationalIdTypeLkp = obj.LookupId;

                    });
                });
                customerVM.customerNIMapping={
                    "NationalIdentifierValue": "",
                    "NationalIdTypeLkp": NationalIdTypeLkp
                };
                if($state.data.info==true) {
                    customerVM.readonly = true;
                    customerVM.StartDateReadonly = true;
                    customerVM.EndDateReadonly = true;

                }
                function findWithAttr(array, attr, value) {
                    for(var i = 0; i < array.length; i += 1) {
                        if(array[i][attr] === value) {
                            return i;
                        }
                    }
                    return -1;
                }
/////////////////// ADD / EDIT INITIALIZATION /////////////////////////////////////////////////////////////////////////
                if (angular.isDefined(resolvedData.Customer.data)) {//EDIT                    
                    customerVM.isEdit=true;
                    customerVM.StartDateReadonly = true;
                    customerVM.vm = resolvedData.Customer.data;
                    customerVM.minEndDate = customerVM.vm.EffectiveStartDate;
                    // customerVM.vm.TmXCustomerBankingDetail=null;
                    customerVM.vm.TmXCustomerBankingDetail=customerVM.vm.TmxCustomerBankingDetails[0];
                    if(angular.isDefined(customerVM.vm.NationalIdentifierValue)){
                        customerVM.customerNIMapping.NationalIdentifierValue= customerVM.vm.NationalIdentifierValue;
                        customerVM.customerNIMapping.NationalIdTypeLkp = NationalIdTypeLkp;
                    }                    
                    if(angular.isDefined(customerVM.vm.TmxCustomerDetail[0].TmxPerson.TmxPersonNationalIdentifier) &&    customerVM.vm.TmxCustomerDetail[0].TmxPerson.TmxPersonNationalIdentifier.length>0) {
                
                        customerVM.customerNIMapping.NationalIDExpiryDate=   customerVM.vm.TmxCustomerDetail[0].TmxPerson.TmxPersonNationalIdentifier[0].NationalIdExpiryDate;
                        customerVM.customerNIMapping.CustomerNationalIdentifierMappingId=customerVM.vm.TmxCustomerDetail[0].TmxPerson.TmxPersonNationalIdentifier[0].PersonNationalIdentifierId;
                    }

                   if(exists(customerVM.vm.TmxCustomerDetail[0].TmxPerson.TmxPersonToAddressMapping) && customerVM.vm.TmxCustomerDetail[0].TmxPerson.TmxPersonToAddressMapping.length==0)
                    {
                        var PersonAddressContact = {
                            TmxPersonAddressContact: [{PersonAddressContactId:0}]
                            
                        };
                        customerVM.vm.TmxCustomerDetail[0].TmxPerson.TmxPersonToAddressMapping.push(PersonAddressContact)
                    }

                    if(resolvedData.Customer.data.TmXCustomerOrganizationRelationMapping && resolvedData.Customer.data.TmXCustomerOrganizationRelationMapping.length>0)   
                    {   
                        let customerOrg= resolvedData.Customer.data.TmXCustomerOrganizationRelationMapping.map((obj) => obj.OrganizationID);
                        customerVM.Organizations = resolvedData.Organizations.data.filter(x=>x.Active_Flag ===1 || customerOrg.includes(x.OrganizationId));                 
                        for(var k=0;k<resolvedData.Customer.data.TmXCustomerOrganizationRelationMapping.length;k++)
                        {
                            if(customerVM.RelationMapping && customerVM.RelationMapping.length>0)
                            {
                                
                               // for (var l = 0; l < customerVM.RelationMapping.length; l++) {
                                    if (findWithAttr(customerVM.RelationMapping, "RelationStatusLkpId", resolvedData.Customer.data.TmXCustomerOrganizationRelationMapping[k].RelationStatusLkpId) > -1) {
                                       var index = findWithAttr(customerVM.RelationMapping, "RelationStatusLkpId", resolvedData.Customer.data.TmXCustomerOrganizationRelationMapping[k].RelationStatusLkpId);
                                        var tempOrganizationRelationMapping = [];
                                        var obj = {
                                            "CustomerMasterId": resolvedData.Customer.data.TmXCustomerOrganizationRelationMapping[k].CustomerMasterId,
                                            "RelationStatusLkpId": resolvedData.Customer.data.TmXCustomerOrganizationRelationMapping[k].RelationStatusLkpId,
                                            "OrganizationId": resolvedData.Customer.data.TmXCustomerOrganizationRelationMapping[k].OrganizationID,
                                            "CustomerToOrganizationRelationMapping": resolvedData.Customer.data.TmXCustomerOrganizationRelationMapping[k].CustomerToOrganizationRelationMapping
                                        }                                        
                                        customerVM.RelationMapping[index].tempOrganizationRelationMapping.push(obj);
                                    }
                                    else
                                    {
                                        var tempOrganizationRelationMapping = [];
                                        var obj = {
                                            "CustomerMasterId":resolvedData.Customer.data.TmXCustomerOrganizationRelationMapping[k].CustomerMasterId,
                                            "RelationStatusLkpId":resolvedData.Customer.data.TmXCustomerOrganizationRelationMapping[k].RelationStatusLkpId,
                                            "OrganizationId": resolvedData.Customer.data.TmXCustomerOrganizationRelationMapping[k].OrganizationID,
                                            "CustomerToOrganizationRelationMapping": resolvedData.Customer.data.TmXCustomerOrganizationRelationMapping[k].CustomerToOrganizationRelationMapping
                                        }                                        
                                        tempOrganizationRelationMapping.push(obj);
                                        var details = {
                                            "tempOrganizationRelationMapping":tempOrganizationRelationMapping,
                                            "RelationStatusLkpId":resolvedData.Customer.data.TmXCustomerOrganizationRelationMapping[k].RelationStatusLkpId
                                        }                                        
                                        customerVM.RelationMapping.push(details);
                                    }
                                //}
                            }
                            else
                            {
                                var tempOrganizationRelationMapping = [];
                                var obj = {
                                    "CustomerMasterId":resolvedData.Customer.data.TmXCustomerOrganizationRelationMapping[k].CustomerMasterId,
                                    "RelationStatusLkpId":resolvedData.Customer.data.TmXCustomerOrganizationRelationMapping[k].RelationStatusLkpId,
                                    "OrganizationId": resolvedData.Customer.data.TmXCustomerOrganizationRelationMapping[k].OrganizationID,
                                    "CustomerToOrganizationRelationMapping": resolvedData.Customer.data.TmXCustomerOrganizationRelationMapping[k].CustomerToOrganizationRelationMapping
                                }
                                tempOrganizationRelationMapping.push(obj);
                                var details = {
                                    "tempOrganizationRelationMapping":tempOrganizationRelationMapping,
                                    "RelationStatusLkpId":resolvedData.Customer.data.TmXCustomerOrganizationRelationMapping[k].RelationStatusLkpId
                                }
                                customerVM.RelationMapping.push(details);
                            
                            }
                               
                        }
                    
                }
                }
                else { //ADD
                    customerVM.vm = resolvedData.Customer;
                    customerVM.StartDateReadonly = false;
                    customerVM.vm.EffectiveStartDate = customerVM.date;
            // making effective end date to NOT display DEFAULT value
                    customerVM.vm.EffectiveEndDate =  new Date(undefined);
            //customerVM.vm.EffectiveEndDate = $scope.populateCustomerDate(customerVM.vm.EffectiveEndDate);//date object
                    customerVM.customerNIMapping.NationalIDExpiryDate =  new Date(undefined);
                    customerVM.vm.TmxCustomerDetail = [];
                    var TmxPerson = {
                        TmxPerson: {
                            PersonDateOfBirth:new Date(undefined),
                            PersonResidenceDuration:0.00
                        }
                    };
         
                    customerVM.vm.TmxCustomerDetail.push(TmxPerson);

            // customerVM.vm.TmxCustomerHousehold[0].DateOfBirth = $scope.populateCustomerDate(customerVM.vm.TmxCustomerHousehold[0].DateOfBirth);//date object
            //define minimum emd date
                    customerVM.minEndDate = customerVM.vm.EffectiveStartDate;
                    customerVM.vm.TmxCustomerDetail[0].TmxPerson.TmxPersonToAddressMapping= [];
           

                    var PersonAddressContact = {
                        TmxPersonAddressContact: []
                    };
                    customerVM.vm.TmxCustomerDetail[0].TmxPerson.TmxPersonToAddressMapping.push(PersonAddressContact)
                    customerVM.vm.TmxCustomerDetail[0].TmxPerson.TmxPersonNationalIdentifier = [];

                }

                customerVM.showStatus = true;
                if (customerVM.vm.EffectiveEndDate < customerVM.date) {
                    customerVM.vm.status = "inactive";
                }
                else if (angular.isDefined(customerVM.vm.TmxUserDevice)) {
                    customerVM.vm.status = "active";
                }
                customerVM.lookup = {};
                lookupService.getGender().then(function(types) {
                    customerVM.lookup.gender = types;
                });
                lookupService.getMaritalStatus().then(function(types) {
                    customerVM.lookup.maritalStatus = types;
                });
                lookupService.getProfession().then(function(types) {
                    customerVM.lookup.profession = types;
                });
                lookupService.getTrainings().then(function(types) {
                    customerVM.lookup.trainings = types;
                });
                lookupService.getResidence().then(function(types) {
             
                    customerVM.lookup.residence = types;
                });
                lookupService.getEducation().then(function(types) {
                    customerVM.lookup.education = types;
                });
                lookupService.getRelationships().then(function(types){
                    customerVM.lookup.relationships=types;
                });
                lookupService.getAddressType().then(function(types){
                    customerVM.lookup.addresstype=types;
                });
                customerVM.getDisability=function(){
            
                    if(angular.isDefined(customerVM.vm.TmxCustomerDetail[0].TmxPerson) && customerVM.vm.TmxCustomerDetail[0].TmxPerson.length>0) {
                        if(angular.isDefined(customerVM.vm.TmxCustomerDetail[0].TmxPerson.PersonDisabilityFlag))
                            return customerVM.vm.TmxCustomerDetail[0].TmxPerson.PersonDisabilityFlag;
                    }

                };
        
                customerVM.disabilityChange=function(){
            
                    if(CustomersEditCtrl.vm.TmxCustomerDetail[0].TmxPerson.PersonDisabilityFlag==true){//value = Yes
                        return false;
                    }
                    else{ // value = No
                        customerVM.vm.TmxCustomerDetail[0].TmxPerson.PersonDisabilityNature="";
                        return true;
                    }

                };
                customerVM.getTrainings=function(){
                    if(angular.isDefined(customerVM.vm.TmxCustomerDetail[0].TmxPerson) && customerVM.vm.TmxCustomerDetail[0].TmxPerson.length>0) {
                        if(angular.isDefined(customerVM.vm.TmxCustomerDetail[0].TmxPerson.PersonTechnicalVocationalTrainingTypeLkp))
                            return customerVM.vm.TmxCustomerDetail[0].TmxPerson.PersonTechnicalVocationalTrainingTypeLkp;
                    }
                };
                customerVM.TrainingsChanged=function(newA){
             
                    if(newA==1){ //value == 'Other'
                        customerVM.disableTrainingsField = false;
                        customerVM.TrainingSpecRequired = true;
                    }
                    else{ //value == some other value
                        customerVM.disableTrainingsField = true;
                        customerVM.vm.TmxCustomerDetail[0].TmxPerson.PersonTechnicalVocationalTraining="";
                        customerVM.TrainingSpecRequired = false;
                    }

                };
                $scope.$watch(customerVM.getDisability,customerVM.disabilityChanged);
                $scope.$watch(customerVM.getTrainings,customerVM.TrainingsChanged);
        
                lookupService.getLookupByType(lkupType.YES_NO_BIT).then(function (response) {
            
                    angular.forEach(response,function(type){
                        type.LookupId = (/true/i).test(type.HiddenValue);
                    });

                    customerVM.YesNoBitLkp = response;
                });


                customerVM.lookup.status = [
                    {
                        HiddenValue: "active",
                        VisibleValue: "Active",
                    },
                    {
                        HiddenValue: "inactive",
                        VisibleValue: "Inactive",
                    }
                ];
        // customerVM.lookup.users = resolvedData.Users.data;
                customerVM.currentStatus = customerVM.getStatus();
        ////////////////////////////////////////////////////
            }]);
})();
